(function(){
  var root=document.querySelector('[data-ob-bundle]');
  if(!root||root.dataset.obNativeInit)return; root.dataset.obNativeInit='1';
  var handle=root.dataset.currentHandle, prod=null, lock=false;
  if(handle){ fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(p){prod=p; updateNativeVis(); fromNative();}).catch(function(){}); }
  function nativeId(){
    var el=document.querySelector('.product-block-buy-buttons [name="id"]')||document.querySelector('[id^="product-form-"] [name="id"]');
    return el?parseInt(el.value,10):null;
  }
  function optsOf(v){ return (v.options||[v.option1,v.option2,v.option3]).filter(function(x){return x!=null;}); }
  function nativeOpts(){
    if(!prod)return null; var id=nativeId(); if(!id)return null;
    var v=prod.variants.filter(function(x){return x.id===id;})[0]; return v?optsOf(v):null;
  }
  function currentRow(){ return root.querySelector('.ob-srow.is-current'); }
  function slot0Name(){ var r=currentRow(); var n=r&&r.querySelector('.ob-srow__name'); return n?(n.textContent||'').trim():''; }
  function slot0IsViewed(){ return !!(prod && slot0Name() && slot0Name()===(prod.title||'').trim()); }
  function nativePickerEl(){ return document.querySelector('.product-block-variant-picker'); }
  function updateNativeVis(){ var el=nativePickerEl(); if(!el||!prod)return; el.style.display=slot0IsViewed()?'':'none'; }
  function slot0Selects(){ var r=currentRow(); return r?r.querySelectorAll('[data-ob-pickers] select'):[]; }
  function applyWidget(opts){
    if(!opts)return;
    var sels=slot0Selects(), changed=[];
    Array.prototype.forEach.call(sels,function(s,i){ if(opts[i]!=null&&s.value!==opts[i]){ s.value=opts[i]; changed.push(s); } });
    changed.forEach(function(s){ s.dispatchEvent(new Event('change',{bubbles:true})); });
  }
  function setNative(val){
    var pick=nativePickerEl(); if(!pick)return;
    var selects=pick.querySelectorAll('select');
    for(var i=0;i<selects.length;i++){ var s=selects[i];
      for(var j=0;j<s.options.length;j++){ var o=s.options[j];
        if(o.value.trim()===val||o.textContent.trim()===val){ if(s.value!==o.value){ s.value=o.value; s.dispatchEvent(new Event('change',{bubbles:true})); } return; }
      }
    }
    var radios=pick.querySelectorAll('input[type=radio]');
    for(var k=0;k<radios.length;k++){ var r=radios[k]; if((r.value||'').trim()===val){ if(!r.checked)r.click(); return; } }
    var els=pick.querySelectorAll('label,button,[data-value]');
    for(var m=0;m<els.length;m++){ var e=els[m]; var t=(e.getAttribute('data-value')||e.textContent||'').trim(); if(t===val){ e.click(); return; } }
  }
  function applyNative(opts){ if(!opts)return; opts.forEach(function(v){ if(v!=null&&v!=='')setNative(v); }); }
  function fromNative(){ if(lock||!slot0IsViewed())return; lock=true; try{ applyWidget(nativeOpts()); } finally { setTimeout(function(){lock=false;},0); } }
  function fromWidget(){ if(lock||!slot0IsViewed())return; lock=true; try{ var sels=slot0Selects(); var opts=Array.prototype.map.call(sels,function(s){return s.value;}); applyNative(opts); } finally { setTimeout(function(){lock=false;},0); } }
  document.addEventListener('change',function(e){
    var t=e.target; if(!t||!t.closest)return;
    if(t.closest('.product-block-variant-picker')||t.closest('.product-block-buy-buttons')){ setTimeout(fromNative,40); }
    else if(t.closest('.ob-srow.is-current [data-ob-pickers]')){ fromWidget(); }
  });
  document.addEventListener('click',function(e){
    var t=e.target; if(!t||!t.closest)return;
    if(t.closest('[data-ob-tier]')){ setTimeout(function(){updateNativeVis();fromNative();},60); setTimeout(function(){updateNativeVis();fromNative();},220); }
    else if(t.closest('[data-ob-picker]')){ var c=0,vi=setInterval(function(){ updateNativeVis(); if(++c>6)clearInterval(vi); },150); }
    else if(t.closest('.product-block-variant-picker')){ setTimeout(fromNative,40); }
  });
  var n=0,iv=setInterval(function(){ updateNativeVis(); fromNative(); if(++n>20)clearInterval(iv); },300);
})();
